import { commonFilter } from './filter';

export default {
  pageName: 'DataMapNewsCrawlers',
  pageId: '20021',
  pagePath: '/opinion/DataMap/NewsCrawlers',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
